import { ref } from '@vue/composition-api'

const getLocalStorage = () => {
	let jd_list_light = JSON.parse(window.localStorage.getItem('jd_list_light'))
	if (jd_list_light) {
		let lsTs = jd_list_light.timestamp
		let now = new Date().getTime()
		if (now - lsTs <= 1000 * 60 * 10) { // 10 Minutes
			return jd_list_light.data
		}
		return false
	}
}

export const useJdListLight = (types) => {
	const jds = ref([])
	const jds_types = ref([])
	const error_message = ref('')
	const is_loading = ref(false)
	const getJdListLight = (types) => {
		is_loading.value = true

		if (!types) {
			let jd_list_light = getLocalStorage()
			if (jd_list_light) {
				jds.value = jd_list_light.jds
				jds_types.value = jd_list_light.jds_types
				is_loading.value = false
				return
			}
		}

		window.vm.$EsMaestro.jobdescriptor_list_light(types)
			.then(result => {
				let jdsTypes = result.jds_types.map(jdType => {
					jdType.class = 'typing-' + jdType.text.toLowerCase().replace(/ /g, '')
					return jdType
				})
				if (window.vm.$user.isAdmin()) {
					jds.value = result.jds
					jds_types.value = jdsTypes
				} else {
					let activeJds = result.jds.filter(jd => {
						return !jd.restricted &&
							!jd.archived &&
							jd.typing !== window.vm.$getConst('MIXIN') &&
							jd.typing !== window.vm.$getConst('MAM')
					})
					jds.value = activeJds
					jds_types.value = jdsTypes.filter(jdType => {
						return jdType.value !== window.vm.$getConst('MIXIN') &&
							jdType.value !== window.vm.$getConst('MAM')
					})
				}
				if (!types) {
					let item = {
						timestamp: new Date().getTime(),
						data: { jds: jds.value, jds_types: jds_types.value }
					}
					window.localStorage.setItem('jd_list_light', JSON.stringify(item))
				}
			})
			.catch(error => {
				error_message.value = error.message
			})
			.finally(() => {
				is_loading.value = false
			})
	}

	return {
		jds,
		jds_types,
		error_message,
		is_loading,
		getJdListLight
	}
}



// WEBPACK FOOTER //
// ./src/composables/jobdescriptor_list_light.js